<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
        <span>{{ modoExcecao ? 'Regra de Exceção' : 'Regra Padrão' }}</span>
        <div class="section-title-actions ms-auto">
            <span class="personalizar-tooltip-wrap"
                [matTooltip]="personalizarTooltip"
                [matTooltipDisabled]="!personalizarBloqueado">
                <button mat-button type="button" class="btn-section"
                    [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0"
                    [disabled]="personalizarBloqueado"
                    (click)="onPersonalizar()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </span>
        </div>
    </div>

    <div class="row g-3">

        <!-- Código -->
        <div class="col-12">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ modoExcecao ? 'Código da exceção' : 'Código' }}</mat-label>
                <mat-select formControlName="indicadorIss">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (c of codigoTributosDaOperacao; track c.codigo) {
                    <mat-option [value]="c.codigo">{{ c.codigo }} – {{ c.descricao }}</mat-option>
                    }
                </mat-select>
                @if (form.get('indicadorIss')?.hasError('required') && form.get('indicadorIss')?.touched) {
                <mat-error>Código é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Alerta do indicador do ISS -->
        @if (texto) {
        <div class="col-12">
            <app-alert-card [type]="texto.alertaTipo" [title]="texto.alertaTitulo">
                {{ texto.alertaTexto }}
            </app-alert-card>
        </div>
        }



        <!-- Valores -->
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota ISS (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="vAliq">
                @if (form.get('vAliq')?.hasError('required') && form.get('vAliq')?.touched) {
                <mat-error>Alíquota do ISS é obrigatória.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Incentivo fiscal -->
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Incentivo fiscal</mat-label>
                <mat-select formControlName="indIncentivo">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (i of indicadoresIncentivo; track i.codigo) {
                    <mat-option [value]="i.codigo">{{ i.descricao }}</mat-option>
                    }
                </mat-select>
                @if (form.get('indIncentivo')?.hasError('required') && form.get('indIncentivo')?.touched) {
                <mat-error>Incentivo fiscal é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Número do Processo (exigibilidade suspensa) -->
        @if (ativo('nProcesso')) {
        <div class="col-12 col-md-8">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Número do Processo</mat-label>
                <input matInput type="text" formControlName="numeroProcesso" maxlength="30">
                @if (form.get('numeroProcesso')?.hasError('required') && form.get('numeroProcesso')?.touched) {
                <mat-error>Número do processo é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>
        }



    </div>
</div>
</div>
